import { RecordTypesECDD } from '../enums/audit-trail.enum';
import { OptionDescription } from '../types/option.type';

export const generalFieldsHide = [
  'id',
  'businessUnitId',
  'salespersonId',
  'customers.uuid',
  'managementOwnerships.uuid',
  'reviewed.id',
  'reviewed.username',
  'customers.beneficialOwner',
  'reviewedBy',
  'transactionType',
  'documentTitle',
  'customers.type',
  'uuid',
  'customers.registrationNumber',

  'customers.residentialAddressDetail.unitNo',
  'customers.residentialAddressDetail.district',
  'customers.residentialAddressDetail.postalCode',
  'customers.residentialAddressDetail.streetName',
  'customers.residentialAddressDetail.addressLine',
  'customers.residentialAddressDetail.blockNumber',
  'customers.residentialAddressDetail.countryCode',
  'customers.residentialAddressDetail.floorNumber',
  'customers.residentialAddressDetail.buildingName',
  'customers.residentialAddressDetail.country',

  'customers.principalAddressOfBusinessDetail',
  'customers.principalAddressOfBusinessDetail.unitNo',
  'customers.principalAddressOfBusinessDetail.district',
  'customers.principalAddressOfBusinessDetail.postalCode',
  'customers.principalAddressOfBusinessDetail.streetName',
  'customers.principalAddressOfBusinessDetail.addressLine',
  'customers.principalAddressOfBusinessDetail.blockNumber',
  'customers.principalAddressOfBusinessDetail.countryCode',
  'customers.principalAddressOfBusinessDetail.floorNumber',
  'customers.principalAddressOfBusinessDetail.buildingName',

  'customers.registeredOfficeAddressDetail',
  'customers.registeredOfficeAddressDetail.unitNo',
  'customers.registeredOfficeAddressDetail.district',
  'customers.registeredOfficeAddressDetail.postalCode',
  'customers.registeredOfficeAddressDetail.streetName',
  'customers.registeredOfficeAddressDetail.addressLine',
  'customers.registeredOfficeAddressDetail.blockNumber',
  'customers.registeredOfficeAddressDetail.countryCode',
  'customers.registeredOfficeAddressDetail.floorNumber',
  'customers.registeredOfficeAddressDetail.buildingName',

  'customers.formCStatus',
  'customers.formU6Status',
  'managementOwnerships.country',
  'managementOwnerships.residentialStatus',
  'managementOwnerships.formU6Status',
  'managementOwnerships.formCStatus',
  'managementOwnerships.formStatus',
  'masterEcdd.unitNo',
  'unitNo',
]


export const RECORD_TYPES_ECDD: Record<RecordTypesECDD, OptionDescription<RecordTypesECDD>> = {
  [RecordTypesECDD.ECDDEntity]: {
    id: RecordTypesECDD.ECDDEntity,
    value: RecordTypesECDD.ECDDEntity,
    name: 'ECDD',
    viewValue: 'ECDD'
  },
};

export const fieldNameMapDCDD: { [key: string]: string } = {
  // Master ECDD fields
  'masterEcdd.code': 'Master DCDD',
  'masterEcdd.transactionType': 'Transaction Type',

  // General fields
  'code': 'Reference No',
  'referenceNo': 'Reference No',
  'action': 'Action',
  'status': 'Status',
  'type': 'Client Type',
  'salesperson': 'RES',
  'salesperson.businessName': 'RES Name',
  'salesperson.ceaRegNo': 'RES Reg. No',
  'representedType': 'RES representing / UCP',
  'masterEcdd.propertyType': 'Type of Property',
  'masterEcdd.propertyTypeOtherDescription': 'Type of Property (Others)',
  'masterEcdd.project': 'Project',
  'masterEcdd.unit': 'Unit',
  'masterEcdd.projectName': 'Project Name',
  'masterEcdd.projectUnitNameOther': 'Unit No',
  'masterEcdd.address': 'Address of Property in Transaction',
  'masterEcdd.address.address': 'Address of Property in Transaction',

  'projectName': 'Project Name',
  'projectUnitNameOther': 'Unit No',
  'address.address': 'Address of Property in Transaction',

  // DCDD specific fields
  'clientType': 'Client Type',
  'propertyType': 'Type of Property',
  'propertyTypeOther': 'Type of Property Other',
  'masterEcdd': 'Master ECDD',

  'clientActingType': 'Acting Capacity',

  'signature': 'Signature',
  'submittedAt': 'Date of Form Completion',
  'submittedBy': 'Submitted By',
  'reviewedAt': 'Approval Date',
  'reviewedBy': 'Approval By',
  'reviewed': 'Reviewed',
  'reviewed.name': 'Approval By',
  'pdfUrl': 'PDF URL',
  'remarks': 'Remarks',
  'agentRemarks': 'Agt Remarks',
  'checklistAt': 'Checklist At',
  'isUsedBy': 'Transaction No',
  'signed': 'Signed',
  'name': 'Full Name',
  'formType': 'Form',
  'formCStatus': 'Form C Status',
  'formU6Status': 'Form U6 Status',

  // Customer fields
  'customers': `Customer's Particulars / Unrepresented Counterparty's Particulars`,
  'amlClient': 'AML Client',
  'kycSearchResult': 'KYC Search Result',

  // EcddCustomerModel fields
  'customers.type': 'Customer Type',
  'customers.formType': 'Form',
  'customers.name': 'Full Name',
  'customers.nricfin': 'NRIC / Passport / Other ID No.',
  'customers.dateOfBirth': 'Date of Birth',
  'customers.residentialAddress': 'Residential Address',
  'customers.nationality': 'Nationality',
  'customers.country': 'Country',
  'customers.residentialStatus': 'Residency Status',
  'customers.gender': 'Gender',
  'customers.occupation': 'Occupation',
  'customers.phone': 'Phone',
  'customers.email': 'Email',
  'customers.identifyingType': 'Type of ID',
  'customers.identifyingTypeOther': 'Type of ID (Others)',
  'customers.signature': 'Signature',
  'customers.registeredOfficeAddress': 'Registered Office Address',
  'customers.principalAddressOfBusiness': 'Principal Address of Business',
  'customers.companyRegistrationNumber': 'UEN / Inc. / Reg. No.',
  'customers.companyIncorporationDate': 'Inc. / Reg. Date',
  'customers.mainBusinessActivity': 'Main Business Activity',
  'customers.legalEntityType': 'Entity / Legal Type',
  'customers.legalEntityTypeOther': 'Entity / Legal Type (Others)',
  'customers.signed': 'Signed',
  'customers.authorizedSignerName': 'Signed By',
  'customers.signedAt': 'Signed Date',
  'customers.kycMatch': 'AML Search Result',
  'customers.kycSearchResult': 'AML Check List',
  'customers.isClientAuthorized': 'Authorisation to Act',
  'customers.seniorManagementIsBeneficialOwner': 'Senior management are beneficial owners?',

  // ManagementOwnershipModel fields
  'managementOwnerships': 'Management Ownerships',
  'managementOwnerships.type': 'Type',
  'managementOwnerships.name': 'Full Name',
  'managementOwnerships.nricfin': 'NRIC / Passport / Other ID No.',
  'managementOwnerships.dateOfBirth': 'Date of Birth',
  'managementOwnerships.residentialAddress': 'Residential Address',
  'managementOwnerships.nationality': 'Nationality',
  'managementOwnerships.occupation': 'Occupation',
  'managementOwnerships.identifyingType': 'Type of ID',
  'managementOwnerships.identifyingTypeOther': 'Type of ID (Others)',
  'managementOwnerships.kycMatch': 'AML Search Result',


  // Metadata
  'metadata': 'Metadata',
  'metadata.reason': 'Reason',
  'metadata.rejectedFile': 'Rejected File',
  'metadata.approvedFile': 'Approved File',
  'metadata.transactionInfor': 'Transaction Code',

  //Regenerate Attachments
  'result': 'Result',
  'propertyTypeOtherDescription': 'Type of Property (Others)',
};

export const RECORD_TYPES_DCDD: Record<RecordTypesECDD, OptionDescription<RecordTypesECDD>> = {
  [RecordTypesECDD.ECDDEntity]: {
    id: RecordTypesECDD.ECDDEntity,
    value: RecordTypesECDD.ECDDEntity,
    name: 'DCDD',
    viewValue: 'DCDD',
    fieldNameMap: fieldNameMapDCDD,
    fieldsHide: [...generalFieldsHide],
  },
};
